<div class="label_properties">
  <small class="debug">{{me}}</small>
  @if (dynamicsInitialized) {
    <div>
      <!--        <div *ngIf="subMimeType">-->
      <!--            <hr/>-->
      <!--            {{ mimeTypeShort | StringJSV2Pipe:stringJSPipeArgs}} > {{ subMimeType | StringJSV2Pipe:stringJSPipeArgs}}-->
      <!--            <hr/>-->
    <!--        </div>-->
    <dynamic-form [fields]="uiConfigInit" (submit)="submit($event)">
    </dynamic-form>
    <hr/>
    @if (fieldType == 'ItemName' || fieldType == 'ItemInfo0' || fieldType == 'ItemInfo1' || fieldType == 'ItemInfo2' || fieldType == 'ItemInfo3') {
      <div>
        <app-font-selector (onChange)="onFontChanged($event, '', 'CatalogItem')" [setConfig]="{i_config: sceneItem}"></app-font-selector>
      </div>
    }
    @if (fieldType == 'title') {
      <div>
        <app-font-selector (onChange)="onFontChanged($event, '', 'RssItem')" [setConfig]="{i_config: sceneItem}"></app-font-selector>
      </div>
    }
    @if (fieldType == 'description') {
      <div>
        <app-font-selector (onChange)="onFontChanged($event, '', 'RssItem')" [setConfig]="{i_config: sceneItem}"></app-font-selector>
      </div>
    }
    @if (fieldType == 'text') {
      <div>
        <app-font-selector (onChange)="onFontChanged($event, '', 'XmlItem')" [setConfig]="{i_config: sceneItem}"></app-font-selector>
      </div>
    }
    @if (mimeTypeLong == 'Stocks') {
      <div>
        <app-font-selector (onChange)="onFontChanged($event, '', 'StockItem')" [setConfig]="{i_config: sceneItem}"></app-font-selector>
      </div>
    }
    @if (fieldType == 'resource' || fieldType == 'ItemResourceMain' || fieldType == 'object') {
      <div>
        <mat-checkbox (change)="toggleAspectRatio()" [checked]="maintainAspectRatio">{{'general.maintainAspectRatio' | transloco}}</mat-checkbox>
      </div>
    }
    @if (fieldType == 'date') {
      <div>
        <app-font-selector (onChange)="onFontChanged($event, '', 'XmlItem')" [setConfig]="{i_config: sceneItem}"></app-font-selector>
        <hr/>
        <mat-form-field class="form-element">
          <mat-label>{{'placeholder.filterList' | transloco}}</mat-label>
          <input inputrestriction="basic1" matInput type="text" (change)="onDateChanged()" name="SearchDualList" class="form-control" [(ngModel)]="dateModel" placeholder="" autocomplete="off"/>
        </mat-form-field>
        <hr/>
        <pre style="text-align: left; white-space: pre-line; font-size: 11px; padding-left: 30px">
          Y Year YY YYYY
          M Month in year M MM MMM
          D Day in month D DD
          E Days in week E EE EEE EEEE
          A AM/PM
          J Hour in Day 0-23
          H Hour in Dat 1-24
          K Hour in am/pm 0-11
          L Hour in dat 1-12
          N Minutes in hour N NN
          S Second in minutes SS
        </pre>
      </div>
    }
    <br/>
    <br/>
  </div>
}
</div>
